import React, { useState } from "react";
import { Popover, Menu } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import { Icon, IconName } from "components/hds";

const StyledMenuItem = styled(Menu.Item)`
	&& {
		width: 150px;
		margin-top: 0;
		margin-bottom: 0;
		line-height: 20px;
		padding: 5px 12px;
		height: initial;
		color: ${({ theme }) => theme.colors.grey700};
		&:hover {
			background-color: ${({ theme }) => theme.colors.grey100} !important;
			color: ${({ theme }) => theme.colors.primary};
		}
		&.ant-menu-item-selected {
			background-color: transparent;
		}
		span {
			margin-left: 10px;
		}
	}
`;

interface SharelinkMenuProps {
	button: React.ReactNode;
	content: { icon: string; label: string; action: () => void }[];
	children?: React.ReactNode;
}

const SharelinkMenu = ({ button, content }: SharelinkMenuProps) => {
	const { t } = useTranslation();
	const [visible, setVisibility] = useState(false);

	const mapContent = (menu: { icon: string; label: string; action: () => void }[]) => {
		return (
			<Menu style={{ borderRight: "none" }}>
				{menu.map((item) => (
					<StyledMenuItem
						icon={<Icon name={item.icon as IconName} size="14px" />}
						key={item.label}
						onClick={() => {
							setVisibility(false);
							item.action();
						}}
						style={{
							fontSize: "14px",
						}}
					>
						{String(t(item.label))}
					</StyledMenuItem>
				))}
			</Menu>
		);
	};

	return (
		<Popover
			content={mapContent(content)}
			trigger="click"
			open={visible}
			onOpenChange={setVisibility}
			placement="bottomRight"
		>
			{button}
		</Popover>
	);
};

export default SharelinkMenu;
